import { render, staticRenderFns } from "./biddingAnnouncement02.vue?vue&type=template&id=0e5d782c&scoped=true&"
import script from "./biddingAnnouncement02.vue?vue&type=script&lang=js&"
export * from "./biddingAnnouncement02.vue?vue&type=script&lang=js&"
import style0 from "./biddingAnnouncement02.vue?vue&type=style&index=0&id=0e5d782c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d782c",
  null
  
)

export default component.exports